import React from "react";
import { Button } from 'antd';

export const SubmitButton = ({ label, disabled, onClick, loading = false }) => {
    return (
        <div className="w-100 submit-button">
            <Button disabled={disabled} onClick={onClick} loading={loading}>{label}</Button>
        </div>
    )
}